export function sendActivationCode(email) {
  const encodedEmail = encodeURIComponent(email);
  const url = `${FRONT_OFFICE_URL}AccountWorker/SendActivationCode?email=${encodedEmail}`;
  return $.post(url);
}

export function sendRecoveryPasswordEmail(workerId) {
  const url = `${FRONT_OFFICE_URL}AccountWorker/SendRecoveryPasswordEmail?workerId=${workerId}`;
  return $.post(url);
}

export function sendRecoveryPasswordSMS(workerId) {
  const url = `${FRONT_OFFICE_URL}AccountWorker/SendRecoveryPasswordSMS?workerId=${workerId}`;
  return $.post(url);
}

export function validateActivationCode(email, activationCode) {
  const encodedEmail = encodeURIComponent(email);
  const url = `${FRONT_OFFICE_URL}AccountWorker/ValidateActivationCode?email=${encodedEmail}&activationCode=${activationCode}`;
  return $.post(url);
}

export function validateRecoveryPasswordCode(emailOrPhone, code, workerId) {
  const encodedEmailOrPhone = encodeURIComponent(emailOrPhone);
  const url = `${FRONT_OFFICE_URL}AccountWorker/ValidateRecoveryPasswordCode?emailOrPhone=${encodedEmailOrPhone}&activationCode=${code}&workerId=${workerId}`;
  return $.post(url);
}

export function sendActivationEmailWithoutUser(workerId) {
  const url = `${FRONT_OFFICE_URL}AccountWorker/SendActivationEmailWithoutUser?workerId=${workerId}`;
  return $.post(url);
}

export function resetPassword(workerId, newPassword, code) {
  const dataToSend = {
    password: newPassword,
    workerId: workerId,
  };
  const _url = `${FRONT_OFFICE_URL}AccountWorker/ResetPassword?activationCode=${code}`;

  return $.ajax({
    url: _url,
    data: JSON.stringify(dataToSend),
    dataType: "json",
    contentType: "application/json",
    method: "POST",
  });
}

export function changePassword(jwt, newPassword) {
  const _url = `${FRONT_OFFICE_URL}AccountWorker/ChangePassword`;

  return $.ajax({
    beforeSend: function (xhr) {
      xhr.setRequestHeader("Authorization", "Bearer " + jwt);
    },
    url: _url,
    data: JSON.stringify(newPassword),
    dataType: "json",
    contentType: "application/json",
    method: "POST",
  });
}

export function activateWorkerWithoutUser(
  activationId,
  password,
  isSubscribed
) {
  const _url = `${FRONT_OFFICE_URL}AccountWorker/ActivateWorkerWithoutUser?activationId=${activationId}`;
  return $.ajax({
    url: _url,
    data: JSON.stringify({
      password,
      notifications: isSubscribed,
    }),
    dataType: "json",
    contentType: "application/json",
    method: "POST",
  });
}
